import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const latestArticles = articles.filter((a) => ![1, 3, 6, 9].includes(a.id)).slice(0, 6);

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20">
      <div className="container-custom">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新内容
            </h2>
            <p className="mt-2 text-sm text-foreground-600">社区实时更新的热门内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs font-medium">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="mt-2 font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.viewCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-1-line"></i> {article.commentCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/zuixin-baoliao"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-500 text-primary-600 rounded-md text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
          >
            浏览更多内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}